import { render, staticRenderFns } from "./company.vue?vue&type=template&id=1f62649a&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=1f62649a&prod&lang=scss"
import style1 from "./company.vue?vue&type=style&index=1&id=1f62649a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f62649a",
  null
  
)

export default component.exports